module.exports = __webpack_public_path__ + "static/media/github.b8e090c3.png";